//export const BASE_URL = 'http://localhost:9000/api/v1';

// const baseURL = process.env.REACT_APP_API_BASE_URL;
// console.log(baseURL);
// export const BASE_URL = `${baseURL}:9000/api/v1`;
// export const BASE_URL_FOR_FILE = `${baseURL}:9000/uploads`;
// export const BASE_URL_SOCKET = `${baseURL}8080`;
// export const BASE_URL = `http://210.89.45.45:1040/api/v1`;

//amar
// export const BASE_URL = 'http://192.168.1.100:8000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://192.168.1.100:8000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.100:8080';

//cheema
//  export const BASE_URL = 'http://192.168.29.140:9000/api/v1';
//  export const BASE_URL_FOR_FILE = 'http://192.168.29.140:9000/uploads';
//  export const BASE_URL_SOCKET = 'http://192.168.29.140:8080';

//Taneja
// export const BASE_URL = 'http://192.168.1.9:8000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://192.168.1.9:8000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';

//ujjivan
// export const BASE_URL = 'http://210.89.45.45:4000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:4000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';

// export const BASE_URL = 'http://210.89.45.45:1020/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:1020/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';

//Budhana
// export const BASE_URL = 'http://192.168.1.48:9000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://192.168.1.48:9000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';


// export const BASE_URL = 'http://210.89.45.45:8000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:8000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';


// export const BASE_URL = 'http://210.89.45.45:1030/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:1030/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';

// export const BASE_URL = 'http://192.168.1.8:9000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://192.168.1.8:9000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.29.2:8080';


// export const BASE_URL = 'http://210.89.45.45:1040/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:1040/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';

// export const BASE_URL = 'http://210.89.45.45:8000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:8000/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';

//Sumit
// export const BASE_URL = 'http://192.168.1.8:9000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://192.168.1.8:9000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.8:8080';


export const BASE_URL = 'http://210.89.45.45:5005/api/v1';
export const BASE_URL_FOR_FILE = 'http://210.89.45.45:5005/uploads';
export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';